import { useTheme } from "../../../components/hooks/useTheme";
import { iconValues } from "../../../utils/iconValues";
import baseURL from "../../../configs/api";
import colorConfigs from "../../../configs/colorConfigs";
import useConfirm from "../../../components/hooks/useConfirm";


type VehiclesProps = {
    goToNextPage: (page: number) => void;
    getDataFromCars: (vehicleClassId: number, selectedVehicleClass: any) => void;
    availableVehicle: any[];
    selectedVehiclesClasses: any;
    summaryData: any;
    isCompletedOrCancelled: boolean;
    reservationId: number;
};

export const Vehicles = ({
    goToNextPage,
    getDataFromCars,
    availableVehicle,
    selectedVehiclesClasses,
    summaryData,
    isCompletedOrCancelled,
    reservationId
}: VehiclesProps) => {
    const { themeStyles } = useTheme();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();

    return (
        <>
            <div className="w-full">
                <div className={`w-full pb-4`}>
                    {
                        selectedVehiclesClasses && (
                            <div className="mb-4">
                                <span className={`text-[14px] font-semibold ${themeStyles.main.textHeadingColor}`}>
                                    Selected Vehicle
                                </span>

                                <div className={`flex justify-between bg-transparent p-2 mt-2 w-full h-full min-h-max rounded-lg shadow-sm border ${themeStyles.main.borderColor}`}>
                                    {/* Image */}
                                    <img
                                        src={
                                            selectedVehiclesClasses?.imagePath.startsWith("data:image/png;base64,")
                                                ? selectedVehiclesClasses?.imagePath
                                                : `${baseURL}vehicleClassFile/Get?name=` + selectedVehiclesClasses?.imagePath
                                        }
                                        alt="vehicle"
                                        className="w-[230px] rounded-md"
                                    />

                                    {/* Info */}
                                    <div className="flex flex-col px-2 w-[34%] gap-1.5">
                                        <span className={`text-[16px] font-semibold ${themeStyles.main.textHeadingColor}`}>
                                            {selectedVehiclesClasses?.vehicleLabel}
                                        </span>

                                        <div className={`flex flex-col items-start gap-1.5 text-xs ${themeStyles.main.textSubHeadingColor}`}>
                                            {
                                                selectedVehiclesClasses?.features
                                                    ?.sort((a: any, b: any) => a?.order - b?.order)
                                                    ?.map((feature: any, indexFeat: number) => {
                                                        const iconData = iconValues?.find((icon) => icon?.value === feature?.icon);
                                                        return (
                                                            <div key={indexFeat} className={`flex items-center gap-1 text-xs ${themeStyles.topBar.tailwindTextColor}`}>
                                                                {
                                                                    iconData && (
                                                                        <span className={`material-symbols-outlined text-[16px]`}>{iconData?.icon}</span>
                                                                    )
                                                                }
                                                                <span>{feature?.label}</span>
                                                            </div>
                                                        )
                                                    })
                                            }
                                        </div>
                                    </div>

                                    {/* Price */}
                                    <div className="flex flex-col gap-1.5 w-[25%]">
                                        {
                                            selectedVehiclesClasses?.recommended && (
                                                <div className="flex justify-end">
                                                    <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold bg-[#D9F4D4]  text-[#039855] border ${themeStyles.main.borderColor}`}>
                                                        Recommended
                                                    </span>
                                                </div>
                                            )
                                        }

                                        <div className="flex flex-col gap-1.5 text-left">
                                            <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                                                <span className="font-semibold">${parseInt(selectedVehiclesClasses?.dailyRate)?.toFixed(2)}</span>
                                                <span className={`text-sm font-normal ${themeStyles.main.textHeadingColor}`}>/Day</span>
                                            </p>

                                            <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                                                <span className="font-semibold"> $
                                                    {Number(summaryData?.totalBasePriceBeforeDiscount)?.toFixed(2)}{" "}
                                                    total for {selectedVehiclesClasses?.days} Day{" "}
                                                    {selectedVehiclesClasses?.hours !== 0 && " and " + selectedVehiclesClasses?.hours + " hours"}</span>
                                            </p>

                                            <p className={`text-xs font-normal ${themeStyles.main.textSubHeadingColor}`}>
                                                Excl. taxes & insurance(s)
                                            </p>

                                            <p className={`text-xs font-semibold ${themeStyles.main.textSubHeadingColor}`}>
                                                Vehicle Available: {selectedVehiclesClasses?.availableVehicles}
                                                (
                                                {
                                                    (
                                                        (parseFloat(selectedVehiclesClasses?.availableVehicles) * 100) /
                                                        parseFloat(selectedVehiclesClasses?.vehicleCount)
                                                    )?.toFixed(2)
                                                }
                                                %
                                                )
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    <span className={`text-[14px] font-semibold mt-2 ${themeStyles.main.textHeadingColor}`}>
                        {
                            selectedVehiclesClasses
                                ? "Select Other Vehicle Class"
                                : "Available Vehicle Class"
                        }
                    </span>

                    {
                        availableVehicle?.map((item: any, index: number) => {
                            return (
                                <div key={index} className="mt-4">
                                    <div className={`flex justify-between bg-transparent p-2 w-full h-full min-h-max rounded-lg shadow-sm border ${themeStyles.main.borderColor}`}>
                                        {/* Image */}
                                        <img
                                            src={
                                                item?.imagePath?.startsWith("data:image/png;base64,")
                                                    ? item?.imagePath
                                                    : `${baseURL}vehicleClassFile/Get?name=` + item?.imagePath
                                            }
                                            alt="vehicle"
                                            className="w-[230px] rounded-md"
                                        />

                                        {/* Info */}
                                        <div className="flex flex-col px-2 w-[34%] gap-1.5">
                                            <span className={`text-[16px] font-semibold ${themeStyles.main.textHeadingColor}`}>
                                                {item?.vehicleLabel}
                                            </span>

                                            <div className={`flex flex-col items-start gap-1.5 text-xs ${themeStyles.main.textSubHeadingColor}`}>
                                                {
                                                    item?.features
                                                        ?.sort((a: any, b: any) => a?.order - b?.order)
                                                        ?.map((feature: any, indexFeat: number) => {
                                                            const iconData = iconValues?.find((icon) => icon?.value === feature?.icon);
                                                            return (
                                                                <div key={indexFeat} className={`flex items-center gap-1 text-xs ${themeStyles.topBar.tailwindTextColor}`}>
                                                                    {
                                                                        iconData && (
                                                                            <span className={`material-symbols-outlined text-[16px]`}>{iconData?.icon}</span>
                                                                        )
                                                                    }
                                                                    <span>{feature?.label}</span>
                                                                </div>
                                                            )
                                                        })
                                                }

                                            </div>
                                        </div>

                                        {/* Price */}
                                        <div className="flex flex-col gap-1.5 w-[25%]">
                                            {
                                                item?.recommended && (
                                                    <div className="flex justify-end">
                                                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold bg-[#D9F4D4]  text-[#039855] border ${themeStyles.main.borderColor}`}>
                                                            Recommended
                                                        </span>
                                                    </div>
                                                )
                                            }

                                            <div className="flex flex-col gap-1.5 text-left">
                                                <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                                                    <span className="font-semibold">${parseInt(item?.dailyRate)?.toFixed(2)}</span>
                                                    <span className={`text-sm font-normal ${themeStyles.main.textHeadingColor}`}>/Day</span>
                                                </p>

                                                <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                                                    <span className="font-semibold"> $
                                                        {parseFloat(item?.days) >= 30
                                                            ? (
                                                                parseInt((parseInt(item?.days) / 30).toFixed(0)) *
                                                                Number(item?.monthilyRate) +
                                                                parseInt(
                                                                    parseInt((parseInt(item?.days) % 30) + "") / 7 + ""
                                                                ) *
                                                                Number(item?.weeklyRate) +
                                                                parseInt(
                                                                    ((parseInt(item?.days) % 30) % 7).toFixed(0)
                                                                ) *
                                                                Number(item?.dailyRate) +
                                                                parseFloat(item?.hours) * Number(item.hourlyRate)
                                                            )?.toFixed(2)
                                                            : parseFloat(item?.days) >= 7
                                                                ? (
                                                                    parseInt((parseInt(item?.days) / 7).toFixed(0)) *
                                                                    Number(item?.weeklyRate) +
                                                                    parseInt((parseInt(item?.days) % 7).toFixed(0)) *
                                                                    Number(item?.dailyRate) +
                                                                    parseFloat(item?.hours) * Number(item?.hourlyRate)
                                                                )?.toFixed(2)
                                                                : (
                                                                    parseFloat(item?.days) * Number(item?.dailyRate) +
                                                                    parseFloat(item?.hours) * Number(item?.hourlyRate)
                                                                )?.toFixed(2)}{" "}
                                                        total for {item?.days} Day{" "}
                                                        {item?.hours !== 0 && " and " + item?.hours + " hours"}
                                                    </span>
                                                </p>

                                                <p className={`text-xs font-normal ${themeStyles.main.textSubHeadingColor}`}>
                                                    Excl. taxes & insurance(s)
                                                </p>

                                                <p className={`text-xs font-semibold ${themeStyles.main.textSubHeadingColor}`}>
                                                    Vehicle Available: {item?.availableVehicles}
                                                    (
                                                    {
                                                        (
                                                            (parseFloat(item?.availableVehicles) * 100) /
                                                            parseFloat(item?.vehicleCount)
                                                        )?.toFixed(2)
                                                    }
                                                    %
                                                    )
                                                </p>
                                            </div>

                                            <button
                                                className={`${item?.availableVehicles <= 0 ? "bg-[#D92D20]" : colorConfigs.btn.main.tailwind} ${item?.availableVehicles <= 0 ? "cursor-not-allowed" : "cursor-pointer"} ${themeStyles.main.borderColor} text-white font-semibold px-2 py-2 rounded text-sm`}
                                                onClick={() => {
                                                    if (item?.availableVehicles > 0 && !isCompletedOrCancelled) {
                                                        if (reservationId > 0) {
                                                            setConfirmData({
                                                                title: 'Warning',
                                                                summary: "Are you sure you want to change the Vehicle Class?",
                                                                confirmBtn: 'Yes',
                                                                isConfirm: (callback: any) => {
                                                                    callback();
                                                                    getDataFromCars(item?.vehicleClassId, item);
                                                                    goToNextPage(2);
                                                                }
                                                            });

                                                            setConfirmPopup(true);
                                                        } else {
                                                            getDataFromCars(item?.vehicleClassId, item);
                                                            goToNextPage(2);
                                                        }
                                                    }
                                                }}
                                            >
                                                {
                                                    item?.availableVehicles <= 0
                                                        ? "Not Available"
                                                        : "Select"
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </>
    )
}